import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Form, Field } from 'react-form';
import swal from 'sweetalert2';
import { associerCopropriete } from '../../App_Code/API';

function isDigit(str) {
    const reg = /^[0-9]+$/;
    return reg.test(str);
}

function isAlNum(str) {
    const reg = /^[A-z0-9\s]+$/;
    return reg.test(str);
}

const EntreeControlee = ({
    onChange, onBlur, field, maxChar, fnc, ...rest
}) => (
    <Field field={field}>
        {(fieldApi) => {
            const { value, setValue, setTouched } = fieldApi;

            return (
                <div>
                    <input
                        {...rest}
                        value={value || ''}
                        onChange={(e) => {
                            if (
                                e.target.value.length > 0 &&
                                (!fnc(e.target.value) || e.target.value.length > maxChar)
                            ) {
                                return;
                            }
                            setValue(e.target.value.toUpperCase());
                            if (onChange) {
                                onChange(e.target.value, e);
                            }
                        }}
                        onBlur={(e) => {
                            setTouched();
                            if (onBlur) {
                                onBlur(e);
                            }
                        }}
                        type="text"
                        className="form-control"
                    />
                </div>
            );
        }}
    </Field>
);

const HelpText = ({ children }) => (
    <small id="help" className="form-text text-muted d-flex justify-content-end mr-1 mb-3">
        {children}
    </small>
);

class PageAjoutCopro extends Component {
    constructor(props) {
        super(props);

        this.premiere = sessionStorage.getItem('premiereCopro');
        this.envoyerInput = React.createRef();
    }

    handleSumbit = (submittedValues) => {
        const { Cop, Pro, Pass } = submittedValues;
        this.envoyerInput.current.disabled = true;

        if (!Cop || !Pro || !Pass) {
            swal({
                type: 'error',
                title: 'Erreur',
                text: 'Veuillez renseigner tous les champs',
            });
            this.envoyerInput.current.disabled = false;
            return;
        }

        associerCopropriete(Cop, Pro, Pass).then((response) => {
            if (response.status === 200 && response.data) {
                swal('Rattachement réussi !', 'Vous êtes désormais rattaché à votre copropriété.', 'success');
                sessionStorage.removeItem('premiereCopro');
                sessionStorage.setItem('droit', response.data);
                this.props.history.push({
                    pathname: '/Chargement',
                    state: { nouvelleCop: parseInt(response.data.split('@')[1], 10), prevLocation: '/' },
                });
            } else {
                const Message = response.data.Message
                    ? response.data.Message.replace(/["]+/g, '')
                    : "Impossible d'ajouter la copropriété.";
                swal('Erreur', Message, 'error');
                this.envoyerInput.current.disabled = false;
            }
        });
    };

    render() {
        return (
            <div className="container col-xl-6">
                {this.premiere && (
                    <div className="alert alert-success" role="alert">
                        <h4 className="alert-heading">Bienvenue sur Gérer-ma-Copro !</h4>
                        <hr />
                        <p>
                            Vous avez créé votre compte adhérent sur <b>Gérer ma Copro</b> avec succès.
                        </p>
                        <p>Pour commencer, veuillez-vous rattacher à votre copropriété.</p>
                    </div>
                )}
                <div className=" card mb-3">
                    <div className="card-body">
                        <h4 className="card-title">Rattachement à une nouvelle copropriété</h4>
                        <hr />
                        <div className="alert alert-primary" role="alert">
                            Merci de vous munir de votre dernier <b>appel de fonds</b> pour saisir vos codes.
                        </div>

                        <div className="image-explications" />
                        <hr />
                        <Form onSubmit={this.handleSumbit}>
                            {formApi => (
                                <form onSubmit={formApi.submitForm}>
                                    <div
                                        id="code-cop"
                                        className="form-group row d-flex justify-content-between m-1 required"
                                    >
                                        <label htmlFor="Cop">Code copropriété</label>
                                        <EntreeControlee
                                            field="Cop"
                                            id="Cop"
                                            placeholder="XXX"
                                            type="text"
                                            maxChar={3}
                                            fnc={isAlNum}
                                        />
                                    </div>
                                    <HelpText>Saisissez au maximum 3 caractères alphanumériques</HelpText>
                                    <div
                                        id="code-pro"
                                        className="form-group row d-flex justify-content-between m-1 required"
                                    >
                                        <label htmlFor="Pro">Code propriétaire</label>
                                        <EntreeControlee
                                            field="Pro"
                                            id="Pro"
                                            placeholder="AAAAAA"
                                            maxChar={6}
                                            fnc={isAlNum}
                                        />
                                    </div>
                                    <HelpText>Saisissez au maximum 6 caractères alphanumériques</HelpText>
                                    <div
                                        id="code-pass"
                                        className="form-group row d-flex justify-content-between m-1 required"
                                    >
                                        <label htmlFor="Pass">Code confidentiel</label>
                                        <EntreeControlee
                                            field="Pass"
                                            id="Pass"
                                            placeholder="1234"
                                            maxChar={4}
                                            fnc={isDigit}
                                        />
                                    </div>
                                    <HelpText>Saisissez au maximum 4 caractères numériques</HelpText>
                                    <div className="text-center m-1">
                                        <button
                                            type="submit"
                                            className="btn btn-lg btn-success"
                                            ref={this.envoyerInput}
                                        >
                                            Rattacher la copropriété
                                        </button>
                                    </div>
                                </form>
                            )}
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}
PageAjoutCopro.displayName = 'PageAjoutCopro';

export default withRouter(PageAjoutCopro);



// WEBPACK FOOTER //
// ./src/components/App/PageAjoutCopro.js